import React, { FC } from 'react'
import baobabSrc from './baobab.svg'
import cerealSrc from './cereal.svg'
import poultrySrc from './poultry.svg'
import vegetableSrc from './vegetable.svg'
import dapSrc from './dap.svg'

export type ProductListFilterIconProps = {
    color?: string
    width?: number | string
    height?: number | string
}

const MaskIcon: FC<ProductListFilterIconProps & { src: string }> = ({
    src,
    color = '#B6B5B5',
    width = 28,
    height = 28
}) => (
    <span
        aria-hidden="true"
        className="product-list-filter-icon"
        style={{
            display: 'inline-block',
            width,
            height,
            backgroundColor: color,
            WebkitMaskImage: `url(${src})`,
            maskImage: `url(${src})`,
            WebkitMaskRepeat: 'no-repeat',
            maskRepeat: 'no-repeat',
            WebkitMaskPosition: 'center',
            maskPosition: 'center',
            WebkitMaskSize: 'contain',
            maskSize: 'contain'
        }}
    />
)

export const BaobabFilterIcon: FC<ProductListFilterIconProps> = (props) => (
    <MaskIcon src={baobabSrc} {...props} />
)

export const CerealFilterIcon: FC<ProductListFilterIconProps> = (props) => (
    <MaskIcon src={cerealSrc} {...props} />
)

export const PoultryFilterIcon: FC<ProductListFilterIconProps> = (props) => (
    <MaskIcon src={poultrySrc} {...props} />
)

export const VegetableFilterIcon: FC<ProductListFilterIconProps> = (props) => (
    <MaskIcon src={vegetableSrc} {...props} />
)

export const DapFilterIcon: FC<ProductListFilterIconProps> = (props) => (
    <MaskIcon src={dapSrc} {...props} />
)
